import React, { Suspense, lazy } from "react";
import { Switch, Route } from "react-router-dom";
// import Header from "./Header";
// import SwipeMenu from "./SwipeMenu";
// import BottomTab from "./BottomTab";

import styled from "styled-components";

import { routes } from "../../../routes";
import { Loading } from "../../loading";

const Footer = lazy(() => import("./Footer"));

const LayoutMain = styled.div`
  min-height: 600px;
  height: 100vh;
`;

// const SidebarCart = styled.div`
//   width: 350px;
//   height: 100vh;
//   background-color: red;
// `;

// const ProductContent = styled.div`
//   // width: calc(100% - 350px);
// `;

const Layout = () => {
  return (
    <>
      {/* <Header /> */}
      <LayoutMain>
        <Suspense fallback={<Loading />}>
          <Switch>
            {routes.map((route, idx) => {
              return route.component ? (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={(props) => <route.component {...props} />}
                />
              ) : null;
            })}
          </Switch>
        </Suspense>        
      </LayoutMain>

      {/* <SidebarCart>       
      </SidebarCart> */}
      {/* if the player is on then return 100px else 50px*/}
      {/* <BottomTab /> */}

      {/* <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense> */}
    </>
  );
};

export default Layout;
